// biome-ignore-all assist/source/organizeImports: This file's exports are intentionally organized by hand.

// Create component dot notation access via exporting subcomponents as *.
// We intentionally import and then re-export, so there is a place to hang
// the top-level jsdoc.

import * as VizContainerParts from './index.parts';

/**
 * `VizContainer` is an experimental new replacement for `VizPanel` that better supports composition when rendering
 * data visualizations.
 */
export const VizContainer = VizContainerParts;

// Export all the types for the subcomponents.
export type * from './actions';
export type * from './body';
export type * from './content-error';
export type * from './header';
export type * from './notices';
export type * from './root';
export type * from './viz-error-boundary';

// Hooks
export * from './hooks';

// Utility functions
export { getMostSevereNoticeType } from './notices/model';
